
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4065"}},[_c('path',{attrs:{"data-name":"Path 121861","d":"M40 0A40 40 0 110 40 40 40 0 0140 0z","fill":"#24f7b8","opacity":".15"}}),_c('g',{attrs:{"data-name":"calendar","fill":"none","stroke":"#01b982","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M33.333 22v3"}}),_c('path',{attrs:{"data-name":"Vector","d":"M46.667 22v3M23.5 35.15h33M57 32.824v15.852C57 54.271 54.167 58 47.556 58H32.444C25.833 58 23 54.27 23 48.676V32.824c0-5.594 2.833-9.324 9.444-9.324h15.112c6.611 0 9.444 3.73 9.444 9.324zM46.162 42.833h.005M46.162 47.833h.005M39.996 42.833h.005M39.996 47.833h.005M33.826 42.833h.005M33.826 47.833h.005"}})])])])
          )
        }
      }
    